<template>
  <div
    role="checkbox"
    tabindex="0"
    :aria-checked="isChecked"
    :id="`${uniqueId}`"
    :key="uniqueId"
    class="relative inline-flex flex-shrink-0 border-1 border-transparent h-5 w-15 rounded-full
    cursor-pointer focus:outline-none transition focus:shadow-outline-green"
    :class="isChecked ? 'bg-green-500' : 'bg-gray-300'"
    @keypress.space="$event.preventDefault(); $emit('input', !value)"
    @click="$emit('input', !value)"
  >
    <span
      aria-hidden="true"
      class="absolute inline-block h-5 w-5 rounded-full bg-white shadow-md transform
      transition ease-in-out duration-200 z-10"
      :class="isChecked ? 'translate-x-10' : 'translate-x-0'"
    >
    </span>
    <span
      aria-hidden="true"
      class="absolute inline-block text-xs font-bold h-5 w-15 px-2 leading-5 transform
      select-none z-0"
      :class="isChecked ? 'text-left text-white' : 'text-right text-gray-600'"
    >
      {{ isChecked ? 'Yes' : 'No' }}
    </span>
  </div>
</template>

<script>
import Utils from '@/components/_mixins/Utils';

export default {
  name: 'ToggleInput',
  mixins: [Utils],
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isChecked() {
      return this.value === true;
    },
  },
};
</script>
